var prepareStackTrace = require("./prepareStackTrace");

module.exports = function () {
  Error.getStackTrace = function (throwable) {
    return throwable.stack;
  };

  return {
    prepareStackTrace: prepareStackTrace
  };
};